import { render, staticRenderFns } from "./ColorPanel.vue?vue&type=template&id=801fdd08"
import script from "./ColorPanel.vue?vue&type=script&lang=js"
export * from "./ColorPanel.vue?vue&type=script&lang=js"
import style0 from "./ColorPanel.vue?vue&type=style&index=0&id=801fdd08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports